// extracted by mini-css-extract-plugin
module.exports = {"link-list":"OrderedLinkList-module__link-list___1gZvg","number-container":"OrderedLinkList-module__number-container___3LdIa","number":"OrderedLinkList-module__number___2F2Sw"};